let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("k9jju")).then(() => parcelRequire('8Pt0F'));